"use client";

import styled from "styled-components";

export const FooterBottomWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--Spacing-12, 1.2rem) 0rem;
`;

export const FooterBottomContentsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2.4rem;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;

  @media only screen and (min-width: 1px) and (max-width: 767px) {
    align-items: flex-start;
  }
`;

export const CopyRights = styled.p`
  color: var(--Color-Common-Text-Interactive-Inverse, #fff);
  font-family: var(--font-plus-jakarta-sans);
  font-size: 1.2rem;
  font-weight: 500;
  min-height: 1.6rem;
  line-height: 130%;
`;

export const CompanyInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const CompanyAddress = styled.p`
  min-height: 1.8rem;
  color: var(--Color-Common-Text-Interactive-Inverse, #fff);
  font-family: var(--font-plus-jakarta-sans);
  font-size: 1.2rem;
  font-weight: 300;
  opacity: 0.8;
  line-height: 130%;
`;

export const FooterFnbWrapper = styled.div``;
